import React from 'react';

interface ILoaderProps {
  message?: string;
}

const Loader: React.FC<ILoaderProps> = ({ message = '' }) => (
  <div id="loadingPage" className={message ? 'guideLoading guideMessage' : 'guideLoading'}>
    {message ? <h1>{message}</h1> : ''}
  </div>
);

export default Loader;